import React from 'react';

import type { Props as FormattedDateTimeProps } from '@swf/sports/components/FormattedDateTime/FormattedDateTime';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';

import styles from './Header.scss';

interface HeaderProps {
  date: FormattedDateTimeProps['date'];
}

export const Header: React.FC<HeaderProps> = ({ date }) => (
  <div className={styles.header}>
    <div className={styles.name}>
      <FormattedDateTime date={date} format="long" hideTime />
    </div>
  </div>
);

export default Header;
